import { formatDate } from '@angular/common';

import { I18nService } from '../../i18n/i18n.service';
import { epicDependencies } from '../../store';
import { PeriodType } from '../../widget/date-range.widget.model';
import { CacheDate } from '../models/cache-model';

export function transformDate(
    value: CacheDate,
    periodType?: PeriodType,
): string {
    const i18nService = epicDependencies.injector.get<I18nService>(I18nService);
    const userLocale = i18nService.locale;

    const formatWithUTC = (dateStr: string): string =>
        formatDate(
            new Date(
                dateStr.trim().toLowerCase().endsWith('z')
                    ? dateStr
                    : `${dateStr}Z`,
            ),
            'MMMM d, yyyy',
            userLocale,
            'UTC',
        );

    const endDateFormatted = formatWithUTC(value.endDate);

    if (periodType === PeriodType.DAY) {
        return endDateFormatted;
    }

    const startDateFormatted = formatWithUTC(value.startDate);
    return `${startDateFormatted} - ${endDateFormatted}`;
}
